import { Component, OnInit, ViewChild } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-detalhe-atualizacao',
  templateUrl: './detalhe-atualizacao.component.html',
  styleUrls: ['./detalhe-atualizacao.component.scss'],
})
export class DetalheAtualizacaoComponent implements OnInit {
  constructor(
    private popoverCtrl: PopoverController
  ) { }

  displayedColumns: string[] = ['dado', 'situacao', 'lastupdated'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  ngOnInit() {
  }

  fecharClicked() {
    this.popoverCtrl.dismiss();
  }

}

export interface PeriodicElement {
  dado: string;
  situacao: string;
  lastupdated: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {dado: 'Temperatura', situacao: 'Em operação', lastupdated: '22/01/2020'},
  {dado: 'Vento', situacao: 'Desativada', lastupdated: '22/01/2020'},
  {dado: 'Chuva', situacao: 'Em instalação', lastupdated: '22/01/2020'},
  {dado: 'Umidade', situacao: 'Em realocação', lastupdated: '22/01/2020'},
  {dado: 'IQAr', situacao: 'Desativada', lastupdated: '22/01/2020'},
  {dado: 'CO', situacao: 'Desativada', lastupdated: '22/01/2020'},
  {dado: 'NO2', situacao: 'Desativada', lastupdated: '22/01/2020'}
];
